import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6,
    _t7;

import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/constants/Breakpoints';
import styled, { css } from 'styled-components';
export const borderStyle = `1px solid ${GREAT_WHITE}`;
export const MerchCardWrapper = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__MerchCardWrapper",
  componentId: "sc-1pwleyq-0"
})(["display:contents;"]);
export const Section = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__Section",
  componentId: "sc-1pwleyq-1"
})([""]);
export const FillerRow = ({
  row,
  commonStyles
}) => /*#__PURE__*/_jsx("div", {
  style: Object.assign({
    gridRowStart: row
  }, commonStyles)
});
const commonGridStyles = css(["display:grid;width:100%;"]);
export const StyledCardGridWrapper = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__StyledCardGridWrapper",
  componentId: "sc-1pwleyq-2"
})(["position:relative;width:100%;left:", ";", ""], ({
  columns
}) => {
  return columns < 3 ? `calc(((100% / 3) * ${3 - columns}) / 2)` : 0;
}, breakpoint.sdMac(_t || (_t = _`
    left: 0;
  `)));
/* stylelint-disable property-no-vendor-prefix */

export const StyledCardGrid = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__StyledCardGrid",
  componentId: "sc-1pwleyq-3"
})(["", " grid-template-columns:repeat( ", ",calc((100% / ", ") - ", "px));max-width:", ";column-gap:16px;@media (min-width:", "px) and (max-width:", "px){min-width:600px;h2{font-size:18px;}}", ";", ";"], commonGridStyles, ({
  columns
}) => columns, ({
  columns
}) => columns, ({
  columns
}) => 16 * (columns - 1) / columns, ({
  columns
}) => {
  return columns < 3 ? `calc(100% / 3 * ${columns})` : 'initial';
}, breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.sdMac(_t2 || (_t2 = _`
    max-width: initial;
    column-gap: 0;
    grid-template-columns: ${0};
    margin-top: 20px;
  `), ({
  columns
}) => `repeat(${columns}, minmax(0, 1fr))`), breakpoint.phoneLarge(_t3 || (_t3 = _`
    width: 94% !important;
  `)));
export const SuiteStarterCardGridWrapper = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__SuiteStarterCardGridWrapper",
  componentId: "sc-1pwleyq-4"
})(["position:relative;width:100%;left:", ";", ""], ({
  columns
}) => {
  return columns < 3 ? `calc((((100% / 3) * ${3 - columns}) * .75) / 2)` : 0;
}, breakpoint.sdMac(_t4 || (_t4 = _`
    left: 0;
  `)));
export const SuiteStarterCardGrid = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__SuiteStarterCardGrid",
  componentId: "sc-1pwleyq-5"
})(["", " grid-template-columns:1fr 1fr;column-gap:64px;max-width:75%;@media (max-width:", "px){max-width:100%;column-gap:32px;}", ";"], commonGridStyles, breakpointValues.sdMac - 1, breakpoint.tabletPortrait(_t5 || (_t5 = _`
    margin-top: 20px;
  `)));
/**
 * This is a StyledCardGrid that will render underneath the existing grid that will
 * display ShadowColumn's underneath the existing columns
 */

export const ShadowCardGrid = styled(StyledCardGrid).withConfig({
  displayName: "MerchCardSharedComponents__ShadowCardGrid",
  componentId: "sc-1pwleyq-6"
})(["background-color:transparent;height:100%;left:0;position:absolute;top:0%;z-index:-1;"]);
/**
 * This is a SuiteStarterCardGrid that will render underneath the existing grid that will
 * display ShadowColumn's underneath the existing columns
 */

export const ShadowSuiteStarterCardGrid = styled(SuiteStarterCardGrid).withConfig({
  displayName: "MerchCardSharedComponents__ShadowSuiteStarterCardGrid",
  componentId: "sc-1pwleyq-7"
})(["background-color:transparent;height:100%;left:0;position:absolute;top:0%;z-index:-1;@media (min-width:", "px) and (max-width:", "px){h2{font-size:18px;}}", ";"], breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tabletPortrait(_t6 || (_t6 = _`
    margin-top: 20px;
  `)));
/**
 * This is a basic div that will be rendered vertically at 100% under existing grid
 * columns and will display an shadow under it
 */

export const ShadowColumn = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__ShadowColumn",
  componentId: "sc-1pwleyq-8"
})(["background:", ";box-shadow:0 1px 5px 0 #2d3e501f;height:100%;border:1px solid ", ";", ";"], OLAF, GREAT_WHITE, breakpoint.sdMac(_t7 || (_t7 = _`
  border-right: ${0};
  }
  &:last-of-type {
    border-right: 1px solid ${0};
  }
  `), ({
  isFreeToStarter
}) => !isFreeToStarter ? `none` : `1px solid ${GREAT_WHITE}`, GREAT_WHITE));